// material ui
import type { Theme } from '@mui/material/styles';

// components
import { inputSurfaceStyles } from '@/theme/Inputs/textFieldCustomization';

export const selectCustomization = () => ({
  MuiOutlinedInput: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => inputSurfaceStyles(theme),
    },
  },

  MuiFilledInput: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        ...inputSurfaceStyles(theme),
      }),
    },
  },
});
